import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {repeat} from 'lit/directives/repeat.js';
import {msg} from '@lit/localize';

import {connect} from 'pwa-helpers';
import store from '../../store';
import {selectPriceDataPerModels} from '../../selectors';
import {fetchPriceData} from '../../slices/priceSlice';

// import priceDataTest from './priceDataTest.json';

@customElement('price-sheet')
export class PriceSheet extends connect(store)(LitElement) {


	static styles = [
		css`
			:host {
				container-type: inline-size;
				overflow: scroll;
				display: block;
				height: 100%;
			}

			@media screen {
				.page {
					width: 90cqw;
					box-sizing: border-box;
					margin: 40px;
					box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.25);
				}
			}
			@media print {
				.page {
					margin: 0;
					box-shadow: none;
				}
			}
		`
	];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.priceDataPerModels = selectPriceDataPerModels(state);
		if (this.priceDataPerModels) {
			this.priceDataPerModels = this.priceDataPerModels.filter(priceDataPM => priceDataPM.featureModelId.endsWith('Extern'));
		}
		//this.priceDataPerModels = priceDataTest.priceDataPerModels.filter(priceDataPM => priceDataPM.featureModelId.endsWith('Extern'));
	}
	connectedCallback() {
		super.connectedCallback();
		store.dispatch(fetchPriceData());
	}

	render() {
		if (!this.priceDataPerModels) return null;
		return html`
			${repeat(
				this.priceDataPerModels,
				(priceDataPM) => priceDataPM.featureModelId,
				(priceDataPM) => html`
					<shared-specsheet-page class="page" title="${priceDataPM.featureModelId}" headLabel="Preisliste">
						<price-data title="${priceDataPM.featureModelId}" .priceData=${priceDataPM}></price-data>
					</shared-specsheet-page>
				`)}`;
	}

}
